export default __webpack_public_path__ + "static/pdr-circles-66b0b7b42092975f0d5502ab646d9fa8.png";